
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';
import FAQ from './FAQ';
import GoogleTagManager from '../components/GoogleTagManager';


function Weddingcarrentalmumbai() {



    const cardData =
    {
        keyword: '  Wedding car rental mumbai',
        heading: 'Deva Cabs: Wedding car rental mumbai',
        headingDescription: 'Deva Cabs offers reliable, elegant, and hassle-free wedding car rental services in Mumbai to make your special day truly memorable. Whether it’s a grand entry for the groom, comfortable rides for guests, or luxury cars for bridal travel, our well-maintained fleet adds style and convenience to your wedding events. Choose from a wide range of premium sedans, SUVs, and decorated cars to suit your theme and preferences. With professional chauffeurs and timely service, Deva Cabs ensures a smooth and classy experience on your big day.',

        top: 'Top Places to Visit in Mumbai with Deva Cabs',

   "topPlaces": [
    {
      "title": "Marine Drive",
      "location": "Mumbai, Maharashtra",
      "description": "Marine Drive is a 3.6-kilometer-long arc-shaped boulevard that stretches from Nariman Point to Girgaon Chowpatty. Also known as the 'Queen’s Necklace' for its glowing curve of street lights at night, it is a beloved seaside promenade for evening walks, breezy bike rides, and romantic sunsets. The backdrop of art deco buildings and the peaceful sound of waves create a rare urban serenity, making Marine Drive a timeless retreat in the heart of Mumbai."
    },
    {
      "title": "Gateway of India",
      "location": "Mumbai, Maharashtra",
      "description": "Located at the waterfront in Colaba, the Gateway of India is Mumbai’s most iconic monument. Built in 1924 to honor the visit of King George V and Queen Mary, this massive basalt arch combines Indo-Saracenic architecture with colonial flair. Overlooking the Arabian Sea and facing the Taj Mahal Palace Hotel, it serves as a central tourist hub, with ferry rides to Elephanta Caves and local photographers capturing the city’s vibrant pulse. The Gateway is not just a historic landmark—it’s a symbol of Mumbai’s pride and resilience."
    },
    {
      "title": "Elephanta Caves",
      "location": "Elephanta Island, Mumbai Harbour",
      "description": "A UNESCO World Heritage Site, the Elephanta Caves are a complex of ancient Hindu and Buddhist rock-cut temples located on Elephanta Island, about 11 km from Mumbai. These 5th–8th century caves are renowned for their incredible sculptures of Lord Shiva, particularly the 20-foot-high Trimurti—the three-faced form of Shiva representing creation, preservation, and destruction. The island is accessible by ferry from the Gateway of India and offers a tranquil and culturally enriching day trip."
    },
    {
      "title": "Siddhivinayak Temple",
      "location": "Prabhadevi, Mumbai, Maharashtra",
      "description": "The Shree Siddhivinayak Ganapati Mandir is one of Mumbai’s most spiritually significant landmarks, drawing millions of devotees each year. Dedicated to Lord Ganesha, the temple is famous for its beautiful black stone idol with a curved trunk and diamond-studded forehead. Rich in faith, energy, and devotion, the temple also showcases architectural beauty with its carved wooden doors and gold-plated sanctum. Tuesday is considered especially auspicious for darshan, attracting celebrities and commoners alike."
    },
    {
      "title": "Chhatrapati Shivaji Maharaj Terminus (CSMT)",
      "location": "Mumbai, Maharashtra",
      "description": "A majestic example of Indo-Gothic architecture, Chhatrapati Shivaji Maharaj Terminus is both a UNESCO World Heritage Site and one of India’s busiest railway stations. Designed by British architect F.W. Stevens in 1887, it features elaborate stone carvings, pointed arches, domes, and turrets. The station is a vital part of Mumbai’s daily life while also standing as a living monument to the city’s colonial legacy and artistic grandeur."
    },
    {
      "title": "Juhu Beach",
      "location": "Mumbai, Maharashtra",
      "description": "Juhu Beach is a bustling stretch of sandy coastline in suburban Mumbai, popular for sunsets, local street food, and Bollywood vibes. From joggers and kite-flyers to food stalls selling vada pav, bhel puri, and kulfi, the beach offers a true slice of Mumbai life. Celebrities often frequent nearby luxury homes, and the beach hosts cultural performances and film shoots throughout the year. It's the perfect blend of leisure and local flavor."
    },
    {
      "title": "Haji Ali Dargah",
      "location": "Worli, Mumbai, Maharashtra",
      "description": "Built in the 15th century, the Haji Ali Dargah is a white-domed Indo-Islamic shrine located on an islet off the coast of Worli. The dargah houses the tomb of Sufi saint Haji Ali Shah Bukhari and is accessible via a narrow causeway during low tide. The spiritual calm, rhythmic sea waves, and panoramic sea views create a unique experience for visitors of all faiths. It is one of the most peaceful and scenic religious sites in Mumbai."
    },
    {
      "title": "Sanjay Gandhi National Park",
      "location": "Borivali, Mumbai, Maharashtra",
      "description": "Spread across 104 square kilometers, Sanjay Gandhi National Park is Mumbai’s green oasis and a rare natural reserve within a bustling metropolis. The park is home to leopards, deer, monkeys, and countless bird species. A major highlight is the Kanheri Caves—ancient Buddhist cave carvings over 2,000 years old. With toy train rides, cycling trails, nature walks, and boating, the park is a perfect weekend escape for families, nature lovers, and adventure seekers."
    },
    {
      "title": "Chor Bazaar",
      "location": "Bhendi Bazaar, South Mumbai, Maharashtra",
      "description": "One of the oldest and most legendary flea markets in India, Chor Bazaar is a chaotic maze of shops offering antiques, Bollywood posters, vintage cameras, old clocks, and second-hand furniture. Despite the name (meaning 'Thieves Market'), it's a legal and vibrant place known for unexpected treasures and bargaining fun. Whether you're a collector or a curious explorer, this market is a true reflection of Mumbai’s vibrant street economy and layered history."
    },
    {
      "title": "Girgaon Chowpatty",
      "location": "Girgaon, Mumbai, Maharashtra",
      "description": "Girgaon Chowpatty is a central beach located at the northern end of Marine Drive. Known for its lively ambiance, it becomes a focal point during Ganesh Chaturthi for idol immersions. Food stalls offer classic Mumbai street snacks like pani puri, pav bhaji, and kulfi. Families, couples, and students often gather here to watch the sunset, fly kites, or simply relax by the sea. The beach offers both spiritual and recreational charm right in the heart of the city."
    }
  ],



  "services": [
    {
      "name": "Wedding Car Rental Mumbai",
      "description": "Deva Cabs offers premium wedding car rental services in Mumbai to make your big day even more special. Choose from a wide selection of luxury cars, vintage models, and decorated vehicles perfect for wedding functions, baraats, and bridal entry. Our chauffeurs are well-groomed and trained for high-profile events, ensuring your special moment is elegant, timely, and stylish."
    },
    {
      "name": "Luxury Wedding Car Rental Mumbai",
      "description": "Make your wedding grand with our luxury wedding car rentals in Mumbai. Deva Cabs offers top-tier vehicles such as BMW, Audi, Jaguar, and Mercedes for the bride and groom. Our luxury cars come with professional chauffeurs, premium interior setups, and decorative options. Ideal for photo shoots, receptions, and bridal entries that need a royal touch."
    },
    {
      "name": "Affordable Wedding Car Hire Mumbai",
      "description": "Planning a beautiful wedding on a budget? Deva Cabs offers affordable wedding car hire services in Mumbai without compromising on quality. Choose from a curated list of stylish sedans and SUVs that are ideal for wedding transportation. Whether it’s for the bride, groom, or guests, we ensure punctual service and well-maintained cars at the best rates."
    },
    {
      "name": "Mumbai Wedding Car Booking",
      "description": "Book your wedding car in Mumbai easily with Deva Cabs' online and offline booking options. Our hassle-free process includes car selection, decoration choices, and time scheduling. With real-time confirmations and flexible rental durations, we ensure your wedding transportation is one less thing to worry about on your special day."
    },
    {
      "name": "Wedding Car Rental with Driver Mumbai",
      "description": "All Deva Cabs’ wedding car rentals in Mumbai come with professionally dressed and trained drivers to ensure smooth and dignified travel. Our chauffeurs are experienced in handling VIP weddings and will assist with entry coordination and photo moments. Enjoy a stress-free ride while we manage the logistics."
    },
    {
      "name": "Wedding Car Rental for Bride Mumbai",
      "description": "Every bride deserves a grand entrance. Deva Cabs offers stunning wedding car rentals for brides in Mumbai. Choose from beautiful cars like Jaguar XF, Mercedes E-Class, or decorated SUVs for a dreamy ride. Our team assists with floral décor, timing, and route planning to make your bridal journey picture-perfect."
    },
    {
      "name": "Wedding Car Hire Mumbai for Guests",
      "description": "Ensure your guests arrive in comfort and style with Deva Cabs' wedding car hire services in Mumbai. We offer bulk bookings for sedans, SUVs, and tempo travellers with dedicated coordination for outstation or local pickups. Provide your guests with a smooth and elegant experience right from the venue to the hotel or home."
    },
    {
      "name": "Wedding Limousine Rental Mumbai",
      "description": "Looking for something extraordinary? Deva Cabs provides wedding limousine rentals in Mumbai to add luxury and glamor to your special event. Our limos are ideal for bridal entries, couple shoots, or VIP family arrivals. Enjoy lavish interiors, red carpet service, and a once-in-a-lifetime experience for your wedding celebration."
    },
    {
      "name": "Book Wedding Car Online Mumbai",
      "description": "Book your wedding car online with Deva Cabs through our website or app. Browse through vehicle options, decoration packages, and driver availability in real time. Our digital system provides instant confirmation, 24/7 support, and seamless changes if needed. A quick and modern way to manage your wedding transportation in Mumbai."
    },
    {
      "name": "Mumbai Wedding Car for Destination Wedding",
      "description": "Hosting a destination wedding in or from Mumbai? Deva Cabs offers luxury and long-distance wedding cars suitable for outstation travel. Whether you're headed to Lonavala, Alibaug, Goa, or Nashik, we provide high-end vehicles with trained chauffeurs and wedding-ready décor to travel in comfort and elegance."
    },
    {
      "name": "Luxury Wedding Car Hire Mumbai",
      "description": "Deva Cabs specializes in luxury wedding car hire in Mumbai for discerning couples. Our fleet includes high-end vehicles like Range Rover, Jaguar XJL, BMW 7-Series, and more. Each vehicle is immaculately maintained, chauffeur-driven, and available with full wedding décor customization. Make a royal statement on your big day."
    },
    {
      "name": "Mumbai Wedding Car Service for Bride and Groom",
      "description": "For the couple of the day, Deva Cabs provides special wedding car services in Mumbai tailored for the bride and groom. We offer dual-car packages, synchronized timing, and chauffeur coordination to ensure seamless entry and exit from your venue. Travel in grace and comfort while we take care of the details."
    },
    {
      "name": "Mumbai Wedding Car Rental for Large Groups",
      "description": "Managing large groups for weddings? Deva Cabs provides coordinated wedding car rentals in Mumbai for family and guests. Choose from MUVs, tempo travellers, and buses for larger group movement. Our dedicated transport coordinators help plan and manage routes, timing, and comfort for everyone involved."
    },
    {
      "name": "Wedding Car Rental Mumbai Price",
      "description": "Wondering about wedding car rental prices in Mumbai? Deva Cabs offers transparent and flexible pricing options to suit every budget. Whether you need the car for a few hours or the whole day, our rates include driver, fuel, and decoration options. Get a quote instantly based on your requirement — no hidden charges."
    },
    {
      "name": "Wedding Car Rental Packages Mumbai",
      "description": "Deva Cabs offers customized wedding car rental packages in Mumbai for every type of wedding. From hourly rentals to full-day and multi-day options, we cater to pre-wedding events, D-Day travel, and post-wedding transportation. Pick from bundled packages for bride, groom, and guests with optional décor and refreshments."
    },
    {
      "name": "Wedding Car Rental Near Me Mumbai",
      "description": "Searching for 'wedding car rental near me' in Mumbai? Deva Cabs operates across Mumbai with a wide network of vehicles and drivers. Our local fleet coverage means faster availability, lower travel charges, and easier coordination. Book your nearest wedding car with confidence and ease."
    }
  ],
  "tableData": [
    ["Wedding Car Rental Mumbai", "-Luxury Wedding Car Rental Mumbai"],
    ["Affordable Wedding Car Hire Mumbai", "-Mumbai Wedding Car Booking"],
    ["Wedding Car Rental with Driver Mumbai", "-Wedding Car Rental for Bride Mumbai"],
    ["Wedding Car Hire Mumbai for Guests", "-Wedding Limousine Rental Mumbai"],
    ["Book Wedding Car Online Mumbai", "-Mumbai Wedding Car for Destination Wedding"],
    ["Luxury Wedding Car Hire Mumbai", "-Mumbai Wedding Car Service for Bride and Groom"],
    ["Mumbai Wedding Car Rental for Large Groups", "-Wedding Car Rental Mumbai Price"],
    ["Wedding Car Rental Packages Mumbai", "-Wedding Car Rental Near Me Mumbai"]
  ],

whychoose: [
  {
    "WhyChooseheading": "Elegant Fleet for Every Wedding Theme",
    "WhyChoosedescription": "Deva Cabs offers a premium selection of wedding cars in Mumbai—from luxurious sedans and stylish SUVs to vintage classics and spacious tempo travellers. Whether your event calls for regal sophistication or modern glam, we provide the perfect vehicle to match your wedding theme and enhance your special day."
  },
  {
    "WhyChooseheading": "Chauffeur-Driven Wedding Cars",
    "WhyChoosedescription": "All our wedding rentals include professional, uniformed chauffeurs who are punctual, well-groomed, and trained in wedding day etiquette. They ensure smooth, safe, and comfortable transportation for the bride, groom, and guests, so you can focus on the celebration without any transportation stress."
  },
  {
    "WhyChooseheading": "Custom Decoration Services Available",
    "WhyChoosedescription": "We offer optional wedding car decorations as part of our service. Whether you prefer fresh flowers, ribbons, or a customized theme, Deva Cabs can arrange elegant décor tailored to your preferences, making your ride truly picture-perfect and Instagram-ready."
  },
  {
    "WhyChooseheading": "Flexible Packages for Your Wedding Needs",
    "WhyChoosedescription": "Whether you need a car for a few hours, a full day, or multiple days for various wedding events (like sangeet, mehendi, reception), we offer flexible rental packages. Our customized plans ensure you only pay for what you need—perfect for both small intimate ceremonies and grand celebrations."
  },
  {
    "WhyChooseheading": "On-Time Arrival and Route Planning",
    "WhyChoosedescription": "Our team plans routes and schedules meticulously to ensure the wedding car arrives exactly on time—whether it’s picking up the bride, heading to the venue, or navigating multiple functions around Mumbai. We understand that timing is everything on your big day."
  },
  {
    "WhyChooseheading": "Luxury Experience at Competitive Rates",
    "WhyChoosedescription": "Enjoy the elegance of luxury cars without breaking your wedding budget. Deva Cabs offers competitive wedding rental rates with transparent pricing and no last-minute surprises. We also provide advance quotes and clear invoicing for easy wedding planning."
  },
  {
    "WhyChooseheading": "All-in-One Transportation Solutions",
    "WhyChoosedescription": "Along with the bride and groom car, we offer bulk booking options for guest transportation. From airport pickups to hotel drops and intercity travel for outstation guests, Deva Cabs ensures everyone travels comfortably and in style."
  },
  {
    "WhyChooseheading": "24/7 Support for Last-Minute Changes",
    "WhyChoosedescription": "Weddings are dynamic, and plans can change. That’s why our support team is available around the clock to handle last-minute route updates, vehicle additions, or any special requests, ensuring everything runs smoothly on your wedding day."
  }
]




















    }









const faqData = [
  {
    question: "Does Deva Cabs provide wedding car rental services in Mumbai?",
    answer: "Yes, Deva Cabs offers premium wedding car rental services in Mumbai. We provide beautifully maintained cars for weddings, baraat processions, and guest transportation."
  },
  {
    question: "What types of cars are available for wedding rentals in Mumbai?",
    answer: "Our wedding fleet includes luxury sedans, premium SUVs, vintage cars, and high-end vehicles like Mercedes, BMW, and Audi for your special day."
  },
  {
    question: "Can the wedding car be decorated as per our theme?",
    answer: "Absolutely. We offer car decoration services as per your wedding theme or preferences. You can also arrange your own décor if preferred."
  },
  {
    question: "Is a chauffeur included with the wedding car rental?",
    answer: "Yes, all our wedding car rentals include professional, uniformed chauffeurs trained for high-profile and ceremonial events."
  },
  {
    question: "Can we rent cars for transporting wedding guests in Mumbai?",
    answer: "Yes, we provide multiple vehicles or tempo travellers for comfortable and efficient guest transportation across wedding venues in Mumbai."
  },
  {
    question: "How far in advance should I book a wedding car with Deva Cabs?",
    answer: "We recommend booking at least 2–4 weeks in advance, especially during peak wedding seasons, to ensure availability of your preferred vehicle."
  },
  {
    question: "Is there a minimum rental duration for wedding cars?",
    answer: "Our wedding car rentals are available on an hourly or full-day basis depending on your requirement. Custom packages are also available."
  },
  {
    question: "What areas in Mumbai do you cover for wedding car rental?",
    answer: "We cover all areas of Mumbai including South Mumbai, Western Suburbs, Eastern Suburbs, Thane, and Navi Mumbai for wedding transportation services."
  },
  {
    question: "Can I get a customized wedding car rental package?",
    answer: "Yes, we offer customized packages based on the number of cars, rental duration, locations, and any special requirements you may have."
  },
  {
    question: "Why choose Deva Cabs for wedding car rental in Mumbai?",
    answer: "Deva Cabs combines elegance, professionalism, and punctuality. With luxury cars, courteous chauffeurs, and customized service, we make your big day even more special."
  }
];

const testimonialData = [
  {
    id: 1,
    name: 'Mr. Arjun Malhotra',
    role: 'Groom',
    review: 'We hired a wedding car from Deva Cabs for my baraat, and it was perfect. The car was well-decorated, arrived on time, and the chauffeur was very courteous.',
    rating: 5,
    quoteIcon: '/img/icon/testi-quote.svg',
  },
  {
    id: 2,
    name: 'Mrs. Pooja Kothari',
    role: 'Event Planner',
    review: 'Deva Cabs is our go-to for wedding transportation in Mumbai. They always provide clean, elegant cars with reliable service—great for both the bride/groom and guest movement.',
    rating: 5,
    quoteIcon: '/img/icon/testi-quote.svg',
  }
];


























    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 8108807171",
            "+91 9764227171",



        ],
        email: "booking@devacab.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Cab Service in Mumbai",
            link: "/Cab-Service-in-Mumbai"
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Cab Service in Navi Mumbai",
            link: "/Cab-Service-in-Navi-Mumbai"
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Cab Service in Thane",
            link: "/Cab-Service-in-Thane"
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Cab Service Near Me Mumbai",
            link: "/Cab-Service-Near-Me-Mumbai"
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Car Rental in Mumbai",
            link: "/Car-Rental-in-Mumbai"
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Corporate Cab Services in Mumbai",
            link: "/Corporate-Cab-Services-in-Mumbai"
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Online Taxi Booking Mumbai",
            link: "/Online-Taxi-Booking-Mumbai"
        },
        {
            place: "/images/keyword/8.jpg",
            text: "Wedding Car Rental Mumbai",
            link: "/Wedding-Car-Rental-Mumbai"
        },
        {
            place: "/images/keyword/9.jpg",
            text: "Tempo Traveller on Rent in Mumbai",
            link: "/Tempo-Traveller-on-Rent-in-Mumbai"
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Innova Crysta on Rent in Mumbai",
            link: "/Innova-Crysta-on-Rent-in-Mumbai"
        },
        {
            place: "/images/keyword/11.jpg",
            text: "Ertiga on Rent in Mumbai",
            link: "/Ertiga-on-Rent-in-Mumbai"
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Mini Bus on Rent in Mumbai",
            link: "/Mini-Bus-on-Rent-in-Mumbai"
        },
        {
            place: "/images/keyword/13.jpg",
            text: "Mumbai Airport Cab Booking",
            link: "/Mumbai-Airport-Cab-Booking"
        },
        {
            place: "/images/keyword/14.jpg",
            text: "Navi Mumbai Car Rental Service",
            link: "/Navi-Mumbai-Car-Rental-Service"
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Mumbai Airport to Pune Cab",
            link: "/Mumbai-Airport-to-Pune-Cab"
        },
        {
            place: "/images/keyword/16.jpg",
            text: "Mumbai Airport to Shirdi Taxi",
            link: "/Mumbai-Airport-to-Shirdi-Taxi"
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Pune to Mumbai Airport Cab",
            link: "/Pune-to-Mumbai-Airport-Cab"
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Pune Airport to Mumbai Cab",
            link: "/Pune-Airport-to-Mumbai-Cab"
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Surat to Mumbai Airport Taxi",
            link: "/Surat-to-Mumbai-Airport-Taxi"
        },
        {
            place: "/images/keyword/20.jpg",
            text: "Nashik to Mumbai Airport Cab",
            link: "/Nashik-to-Mumbai-Airport-Cab"
        },
        {
            place: "/images/keyword/21.jpg",
            text: "Mumbai to Nashik Cab",
            link: "/Mumbai-to-Nashik-Cab"
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Mumbai to Shirdi Cab",
            link: "/Mumbai-to-Shirdi-Cab"
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Mumbai to Lonavala Cab",
            link: "/Mumbai-to-Lonavala-Cab"
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Mumbai to Khandala Cab",
            link: "/Mumbai-to-Khandala-Cab"
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Mumbai to Lavasa Cab",
            link: "/Mumbai-to-Lavasa-Cab"
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Mumbai to Matheran Cab",
            link: "/Mumbai-to-Matheran-Cab"
        }
    ];



    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },

    ];


const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Wedding Car Rental Mumbai",
  "image": "https://devacab.com/assets/images/wedding-car-rental-mumbai.jpg", // Replace with actual image URL
  "description": "Deva Cabs offers luxury and affordable wedding car rentals in Mumbai. Choose from vintage, premium SUVs, sedans, and decorated cars with chauffeur-driven service for a perfect wedding day transportation.",
  "brand": {
    "@type": "Brand",
    "name": "Deva Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "1500"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "3000",
    "availability": "https://schema.org/InStock",
    "url": "https://devacab.com/wedding-car-rental-mumbai" // Replace with actual page URL
  }
};





    return (
        <div>
<GoogleTagManager/>
<Helmet>
  <title>Wedding Car Rental Mumbai | Luxury & Vintage Wedding Cars | Deva Cabs</title>
  <meta 
    name="description" 
    content="Book wedding car rentals in Mumbai with Deva Cabs. Luxury, vintage, decorated, and chauffeur-driven cars for weddings. Premium SUVs, sedans, and limos available for your special day." 
  />
  <meta 
    name="keywords" 
    content="Wedding Car Rental Mumbai, Mumbai luxury wedding car, Vintage car hire for wedding Mumbai, Mumbai wedding cab service, Chauffeur-driven wedding car Mumbai, Premium wedding SUV rental Mumbai, Affordable wedding cars Mumbai, Sedan hire for wedding Mumbai, Decorated wedding car Mumbai, Wedding limo rental Mumbai, Exotic cars for wedding Mumbai, Wedding event cab Mumbai, Bridal entry car Mumbai, Groom entry car hire Mumbai, Book wedding cab online Mumbai, Wedding car with driver Mumbai, Wedding transportation service Mumbai, Wedding day car rental Mumbai" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


            <div className="breadcumb-wrapper" >
                <div className="container">
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                    </div>
                </div>
            </div>



            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/8.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#F8911B', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolor'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                // padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolor">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    // padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolor">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className=''>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Deva Cabs</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">


                                                <FAQ faqData={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialKeyword testimonialData={testimonialData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1" key={e.text}>
                                        <a
                                            href={e.link} // Use the separate link for each item
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt={e.text} />
                                            </div>
                                            <div className="b2">
                                                <a href={e.link} className="px-3 colorr">{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #562018',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#562018' }}>
                                            <h4 className=" lead fw-semibold whitt text-white bg-ora">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+91 8108807171" className="d-block  text-white">+91 8108807171</a>
                                                <a href="tel:+91 9764227171" className="d-block  text-white">+91 9764227171</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#562018' }}>
                                                <h4 className=" fw-semibold lead whitt text-white bg-ora">Email</h4>
                                                <a href="mailto:booking@devacab.com" className=" text-white d-block">
                                                    booking@devacab.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#562018' }}>
                                                <h4 className=" fw-semibold lead whitt text-white bg-ora">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Deva Cabs<br />
                                                        SS-2 404 Sector -17 Behind Mother India School Koparkhairne Navi Mumbai 400709
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </section>

        </div>
    );
}

export default Weddingcarrentalmumbai;